module.exports = __webpack_public_path__ + "assets/784040d8317e11380c034f90c92e3763.png";